(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/coupon/wager.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/coupon/wager.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


const {
  Redirect,
  withRouter
} = ReactRouterDOM;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  createWager: createNewWager
} = svs.components.payment.createWager;
const {
  wagerPaymentFlow
} = svs.components;
const {
  standardFlow,
  marketplaceFlow,
  executePayment
} = wagerPaymentFlow;
const {
  groupTypes
} = svs.components.marketplaceData.constants;

const log = new svs.core.log.Logger('trinidad.challenge');
const resolveMarketplaceBetProperties = () => {
  const betProps = ['GROUP'];
  if (svs.challenge.data.isRetailerAdmin) {
    betProps.push('GROUP_B2C');
  }
  return betProps;
};
const convertToOutcomes = {
  1: 0,
  X: 1,
  2: 2
};
const {
  getMarketplaceAccount
} = svs.challenge.helpers;
const createWager = data => ({
  bagType: 0,
  bets: [{
    betAmountSalesGroup1: svs.utils.format.CurrencyAsJupiterString(data.boardData.betSum),
    betAmountSalesGroup2: '0,00',
    betProperties: getMarketplaceAccount() ? resolveMarketplaceBetProperties() : [],
    drawNum: data.boardData.drawNumber,
    game1X2Boards: [{
      boardData: data.boardData.boardData,
      boardProps: data.boardProps ? [data.boardProps] : [],
      systemNum: 1,
      systemType: [data.boardData.systemType],
      uRowData: [0, 0, 0, 0, 0, 0, 0, 0]
    }],
    numDraws: 1,
    productId: 'TMIX',
    rowPriceMulti: data.boardData.rowPriceMulti
  }],
  crc: 0,
  marketInfo: 0,
  valid: data.boardData.valid
});
const createWagerProps = data => _objectSpread({
  betAmount: data.boardData.betSum,
  extradata: {
    quickpick: data.quickPick,
    system: data.boardData.systemType,
    rowAmount: data.rowAmount
  },
  message: data.payMessage,
  productId: 'TMIX'
}, data.marketplaceAccount ? {
  marketplaceAccount: data.marketplaceAccount
} : {});
class PayWager extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      redirect: false
    });
    this.onPaySuccess = this.onPaySuccess.bind(this);
    this.onPayError = this.onPayError.bind(this);
    this.onClickImpossibleRows = this.onClickImpossibleRows.bind(this);
  }
  componentDidUpdate(prevProps) {
    const {
      isPaymentInitialized,
      boardData
    } = this.props;
    if (!prevProps.isPaymentInitialized && isPaymentInitialized) {
      this.initPayment(boardData);
    }
  }
  componentWillUnmount() {
    const {
      cancelPayment
    } = this.props;
    const impossibleRowEl = document.querySelector('.impossible-rows-read-more');
    if (impossibleRowEl) {
      impossibleRowEl.removeEventListener('click', this.onClickImpossibleRows);
    }

    svs.components.Modal.hide();
    cancelPayment();
  }
  initPayment(boardData) {
    if (svs.core.detect.feature('ft-wager-challenge')) {
      this.finalizeNewPayment(boardData);
    } else {
      this.finalizePayment(boardData);
    }
  }
  async finalizeNewPayment(boardData) {
    const {
      draw,
      coupon,
      paymentSuccess,
      cancelPayment,
      clearCoupon
    } = this.props;
    const marketplaceAccount = getMarketplaceAccount();
    const {
      productId,
      drawNumber,
      rowPrice: minRowPrice
    } = draw;
    const {
      chosenBetPrice,
      xpertenMode
    } = coupon;
    const wager = createNewWager().addBet(productId, bet => {
      bet.setDrawNumber(drawNumber);
      bet.setRowPrice(chosenBetPrice);
      bet.setRowPriceMulti(chosenBetPrice / parseInt(minRowPrice, 10));
      bet.addBoard(wagerBoard => {
        if (xpertenMode) {
          wagerBoard.addBoardProperty(xpertenMode);
        }
        boardData.boardData.forEach(outcomes => {
          const value = outcomes.split('').map(outcome => convertToOutcomes[outcome]);
          wagerBoard.addOutcomes(value);
        });
      });
    });
    const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
    if (isSelfService && wagerPaymentFlow.selfServiceFlow) {
      const regCloseTime = formatDate(draw.regCloseTime, true, true);
      const wagerCount = await wagerPaymentFlow.selfServiceFlow.createSelfServicePaymentFlow({
        wagers: [wager],
        regCloseTimes: [regCloseTime]
      });
      if (!wagerCount) {
        cancelPayment();
        return;
      }
      clearCoupon(draw.drawNumber);
      paymentSuccess();
      return;
    }
    let paymentBuilder;
    if (marketplaceAccount) {
      var _marketplaceAccount$s;
      const commissionPercent = (_marketplaceAccount$s = marketplaceAccount.selectedCommissionPercent) !== null && _marketplaceAccount$s !== void 0 ? _marketplaceAccount$s : marketplaceAccount.commissionPercent;
      wager.setCommissionPercent(commissionPercent);
      wager.setActivatedDrawId(parseInt(marketplaceAccount.activatedDrawId, 10));
      wager.setRole(commissionPercent ? groupTypes.RETAILER : groupTypes.PRIVATE);
      paymentBuilder = marketplaceFlow.createMarketplacePaymentFlow({
        config: {
          haltPaymentOnException: true
        },
        wagers: [wager]
      });
    } else {
      paymentBuilder = standardFlow.createStandardPaymentFlow({
        config: {
          haltPaymentOnException: true
        },
        wagers: [wager]
      });
    }
    const [, error] = await executePayment.executePayment(paymentBuilder);
    if (error) {
      cancelPayment();
      return;
    }
    clearCoupon(drawNumber);
    this.setState({
      redirect: true
    });
    paymentSuccess();
  }
  finalizePayment(boardData) {
    const {
      draw,
      coupon,
      cancelPayment,
      paymentSuccess,
      clearCoupon
    } = this.props;
    const marketplaceAccount = getMarketplaceAccount();
    const wager = createWager({
      boardData,
      boardProps: coupon.xpertenMode,
      marketplaceAccount
    });
    const wagerProps = createWagerProps({
      boardData,
      marketplaceAccount,
      payMessage: svs.components.sport.getPaymentConfirmMessage({
        amount: boardData.betSum,
        marketplaceGroup: marketplaceAccount ? marketplaceAccount.name : null,
        productName: 'Challenge'
      }),
      quickPick: coupon.xpertenMode,
      rowAmount: coupon.chosenBetPrice
    });
    if (wager.valid) {
      wager.minRowPrice = coupon.amounts[0];
      this.wager = wager;
      const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
      if (marketplaceAccount) {
        wager.commissionPercent = marketplaceAccount.selectedCommissionPercent || null;
      }
      if (isSelfService) {
        const productFlag = wagerProps.productId;
        const cost = wagerProps.betAmount;
        const regCloseTimeStr = draw ? draw.regCloseTime : null;
        const regCloseTime = new Date(regCloseTimeStr);
        const description = "Spelstopp: ".concat(formatDate(regCloseTime, true, true));
        const wagerWrapper = svs.components.selfserviceCart.generateProductItem({
          wagers: wager,
          isLive: false,
          headers: {
            source: 'SvS:LB:ITS'
          },
          productFlag,
          cost,
          description
        });
        svs.components.selfserviceCart.getCartInstance().actions.addItem(wagerWrapper, err => {
          if (err) {
            cancelPayment();
          } else {
            clearCoupon(draw.drawNumber);
            paymentSuccess();
          }
        });
      } else {
        svs.lbUtils.wager.pay(wager, wagerProps, this.onPaySuccess, this.onPayError, cancelPayment);
      }
    }
  }
  onPaySuccess(data) {
    var _data$wagerAmounts, _data$CreateWagerRepl, _this$wager, _this$wager2;
    const {
      draw,
      clearCoupon,
      updateAccountBalance,
      paymentSuccess
    } = this.props;
    const originalAmount = parseInt(this.wager.bets[0].betAmountSalesGroup1, 10);
    const betAmount = parseInt(data.wagerAmounts ? (_data$wagerAmounts = data.wagerAmounts) === null || _data$wagerAmounts === void 0 ? void 0 : _data$wagerAmounts.betAmount : data === null || data === void 0 || (_data$CreateWagerRepl = data.CreateWagerReply) === null || _data$CreateWagerRepl === void 0 ? void 0 : _data$CreateWagerRepl.betAmount, 10);
    const diffAmount = originalAmount - betAmount;
    const impossibleRows = diffAmount / ((_this$wager = this.wager) === null || _this$wager === void 0 || (_this$wager = _this$wager.bets[0]) === null || _this$wager === void 0 ? void 0 : _this$wager.rowPriceMulti) / (this === null || this === void 0 || (_this$wager2 = this.wager) === null || _this$wager2 === void 0 ? void 0 : _this$wager2.minRowPrice);
    if (impossibleRows > 0) {
      setTimeout(() => {
        this.dialog = new svs.components.dialog.Confirm({
          actions: [{
            callback: () => {
              window.location.href = "".concat(svs.core.urlMapping.get('challengeMyBetsHome'), "/").concat(data.wagerClientSerial);
            },
            title: 'Till spelet'
          }, {
            title: 'Ok'
          }],
          branding: svs.components.dialog.branding.SPORT,
          icon: 'help-2',
          message: [{
            text: "Ditt system inneh\xF6ll ".concat(impossibleRows, " rad").concat(impossibleRows > 1 ? 'er' : '', "\n              med kombinationer som inte \xE4r m\xF6jliga att vinna p\xE5. Den nya systemkostnaden blev\n              ").concat(svs.utils.format.Currency(betAmount), " kr.<br />\n              <a class=\"impossible-rows-read-more\">Mer information</a>"),
            type: svs.components.dialog.message.TEXT
          }],
          title: 'Dina kombinationer går inte att vinna på'
        });
        svs.components.dialog.api.add(this.dialog);
        this.listenToReadMoreClick();
      });
    } else {
      const marketplaceAccount = getMarketplaceAccount();
      let marketPlaceUrl;
      if (marketplaceAccount) {
        marketPlaceUrl = svs.core.urlMapping.get('marketplace') + svs.components.marketplace.helpers.getTeamUrl(marketplaceAccount.groupId, marketplaceAccount.name, 'spel', marketplaceAccount.containerId, marketplaceAccount.activatedDrawId);
      }
      svs.components.sport.getPaymentDoneMessage({
        amount: betAmount,
        isRetailer: svs.challenge.data.isRetailerAdmin,
        marketplaceUrl: marketPlaceUrl,
        productName: 'Challenge'
      }, messageObject => {
        svs.components.dialog.api.add(new svs.components.dialog.Confirm(messageObject.paymentDoneDialogConfig));
      });
    }
    clearCoupon(draw.drawNumber);
    let roomKeys = [];
    if (draw.roomKeys) {
      roomKeys = draw.roomKeys;
    }
    if (data && data.wagerClientSerial) {
      svs.components.app_notifications.setUpAppNotifications({
        productId: svs.challenge.constants.PRODUCT_ID,
        roomKeys,
        wagerSerial: data.wagerClientSerial
      });
    }
    updateAccountBalance();
    this.setState({
      redirect: true
    });
    paymentSuccess();
  }
  onPayError(response) {
    const {
      paymentFailed
    } = this.props;
    const errCodestr = String(response.error.code);
    const errCode = parseInt(errCodestr.replace(/\s/g, ''), 10);
    let errTitle = '';
    let errMessage = '';
    const marketplaceAccount = getMarketplaceAccount();
    switch (errCode) {
      case 2:
        if (marketplaceAccount) {
          errTitle = 'Minsta möjliga systemstorlek är 10kr';
        }
        break;
      case 100005:
        errTitle = 'Du har blivit utloggad. Vänligen logga in igen.';
        break;
      case 8124:
        errTitle = 'Omgången är stängd för spel, vänligen försök senare';
        break;
      case 8105:
        errTitle = 'Omgången har stängt';
        break;
      case 8107:
        errTitle = 'Omgången har inte öppnat för spel, vänligen försök senare';
        break;
      case 83:
        errTitle = 'Omöjlig spelkombination';
        errMessage = "Spelet gick inte att betala p\xE5 grund av att spelkombinationen inte \xE4r m\xF6jlig att vinna p\xE5.<br />\n            <a class=\"impossible-rows-read-more\">Mer information</a>";
        break;
      default:
    }
    svs.sport.sport_common.showErrorDialog(errTitle, errMessage);
    this.listenToReadMoreClick();
    log.debug("Error in payment: ".concat(response.error.code, ": ").concat(response.error.message));
    paymentFailed();
  }
  onClickImpossibleRows(e) {
    const {
      openSpelguide
    } = this.props;
    e.preventDefault();
    openSpelguide();
    svs.components.dialog.api.close();
  }
  listenToReadMoreClick() {
    if (document.querySelector('.impossible-rows-read-more')) {
      document.querySelector('.impossible-rows-read-more').addEventListener('click', this.onClickImpossibleRows);
    }
  }
  render() {
    const {
      redirect
    } = this.state;
    if (redirect) {
      return React.createElement(Redirect, {
        push: true,
        to: ""
      });
    }
    return null;
  }
}


const {
  getDrawByDrawNumber,
  getCouponByDrawNumber
} = svs.challenge.helpers;
const mapStateToProps = (state, _ref) => {
  let {
    match
  } = _ref;
  const drawNumber = Number(match.params.drawNumber);
  return {
    boardData: svs.challenge.getBoardData(state, drawNumber),
    coupon: getCouponByDrawNumber(state, drawNumber),
    draw: getDrawByDrawNumber(drawNumber, state),
    isPaymentInitialized: state.isPaymentInitialized
  };
};
const {
  openSpelguide,
  clearCoupon,
  paymentSuccess,
  paymentFailed,
  cancelPayment,
  receiveAccountBalance
} = svs.challenge.actions;
svs.challenge.PayWager = withRouter(ReactRedux.connect(mapStateToProps, {
  cancelPayment,
  clearCoupon,
  openSpelguide,
  paymentFailed,
  paymentSuccess,
  updateAccountBalance: receiveAccountBalance
})(PayWager));

 })(window);